import clsx from 'clsx';
import React from 'react';
import FocusLock from 'react-focus-lock';
import Blanket from '@cmpkit/blanket';
import { Animation } from './Animation';
import Positioner from './Positioner';
export default function Modal(props) {
    const { children, width, className, isOpen, onCloseComplete, onOpenComplete, shouldCloseOnOverlayClick, shouldCloseOnEscapePress, stackIndex, testId, disableFocusTrap, onClose, size, } = props;
    const isBackground = stackIndex != null && stackIndex > 0;
    const handleOverlayClick = (e) => {
        if (shouldCloseOnOverlayClick) {
            onClose === null || onClose === void 0 ? void 0 : onClose(e);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key !== 'Escape' && !isBackground) {
            return;
        }
        if (shouldCloseOnEscapePress) {
            e.stopPropagation();
            onClose === null || onClose === void 0 ? void 0 : onClose(e);
        }
    };
    return (React.createElement(Animation, { in: isOpen, onExited: onCloseComplete, onEntered: onOpenComplete, stackIndex: stackIndex }, ({ fade, slide }) => (React.createElement("div", { className: 'modal--fill-screen', style: fade, "aria-hidden": isBackground, onKeyDown: handleKeyDown },
        React.createElement(Blanket, { isTinted: true, onBlanketClicked: handleOverlayClick }),
        React.createElement(Positioner, { style: slide, width: width, size: size },
            React.createElement(FocusLock, { disabled: !isOpen || disableFocusTrap },
                React.createElement("div", { className: clsx('modal__dialog', className), role: 'dialog', "data-testid": testId, tabIndex: -1 }, children)))))));
}
//# sourceMappingURL=Modal.js.map